module.exports = __webpack_public_path__ + "static/ocorie-hm-splash-img-1-fce19eeef7370920794580cc4b97cc6b.png";